module.exports = __webpack_public_path__ + "static/media/Slurpuff_gaussian2.84c163df.png";